<template>
  <v-container v-if="loaded">
    <v-btn text class="float-right" :to="{ name: 'tests' }">Назад</v-btn>
    <h1 class="display-3">{{ test.name }}</h1>
    <v-tabs>
      <v-tab>О тесте</v-tab>
      <v-tab>Рейтинг</v-tab>
      <v-tab-item>
        <p>{{ test.description }}</p>
        <p>Тест состоит из {{ test.size | questions }} по следующим темам:</p>

        <ul>
          <li v-for="item in sections" :key="item.name">
            {{ item.name }}
          </li>
        </ul>
        <p>
          В ходе тестирования предлагается ответить на
          {{ test.sizeLimit | questions }} в течение
          {{ test.timeLimit | minutes }}.
        </p>
        <v-divider class="my-4" />
        <v-btn large color="primary" block @click="start"
          >Приступить к тестированию</v-btn
        >
      </v-tab-item>
      <v-tab-item>
        <RatingTable
          :top5="top5"
          :myRank="myRank"
          :myScore="myScore"
          :count="count"
        />
      </v-tab-item>
    </v-tabs>
  </v-container>
  <v-container v-else>
    <v-skeleton-loader
      class="mt-4"
      loading
      tile
      type="table-heading, paragraph, button"
    ></v-skeleton-loader>
  </v-container>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import RatingTable from '../components/RatingTable'
export default {
  name: 'Test',
  components: {
    RatingTable
  },
  data() {
    return {
      test: {},
      sections: [],
      top5: [],
      myRank: 0,
      myScore: {},
      count: 0,
      loaded: false,
      canStart: false,
      canStartReason: ''
    }
  },
  mounted() {
    const p1 = this.request('api/tests/' + this.$route.params.id).then(body => {
      this.test = body.data.test
      this.sections = body.data.sections
      this.top5 = body.data.top5
      this.myRank = body.data.myRank
      this.myScore = body.data.myScore
      this.count = body.data.test.count
    })
    const p2 = this.request('/session/check/' + this.$route.params.id).then(
      body => {
        this.canStart = body.data.result
        this.canStartReason =
          body.data.reason || 'невозможно начать тестирование сейчас'
      }
    )
    Promise.all([p1, p2]).then(() => {
      this.loaded = true
    })
  },
  methods: {
    start() {
      if (!this.canStart) {
        return this.message({ text: this.canStartReason, color: 'error' })
      }
      this.request({
        url: '/session/create/' + this.$route.params.id,
        method: 'post'
      }).then(body => {
        body.message && this.message(body.message)
        const { sessionId } = body.data
        this.$router.push({
          name: 'session',
          params: { id: sessionId }
        })
      })
    },
    ...mapMutations(['message']),
    ...mapActions(['request'])
  }
}
</script>
<style scoped>
tr.special td {
  font-weight: bold;
}
</style>
